import { statusIcon } from "../activityCompletionRules";

const SectionShell = ({
  sectionId,
  title,
  sectionStatus,
  isActive,
  isDisabled,
  disabledMessage,
  sectionRef,
  children,
  onHeaderClick,
  contentProps = {},
}) => {
  const icon = statusIcon(sectionStatus);

  return (
    <section
      id={`section-${sectionId}`}
      data-section-id={sectionId}
      ref={sectionRef}
      className={`scroll-mt-[168px] rounded-xl border bg-white shadow-sm transition-colors duration-200 ${
        isActive ? "border-2 border-primary ring-1 ring-primary/10" : "border-gray-200"
      }`}
    >
      <button
        type="button"
        onClick={onHeaderClick}
        className="w-full border-b border-gray-100 px-4 py-3.5 text-left sm:px-5"
      >
        <div className="flex items-center gap-3">
          <span
            className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-bold ${
              sectionStatus === "complete"
                ? "bg-emerald-50 text-emerald-600"
                : sectionStatus === "incomplete"
                ? "bg-amber-50 text-amber-600"
                : isActive
                ? "bg-primary/10 text-primary"
                : "bg-gray-100 text-gray-400"
            }`}
          >
            {icon}
          </span>
          <h3 className={`truncate text-sm font-bold ${isActive ? "text-gray-900" : "text-gray-800"}`}>
            {title}
          </h3>
          {isDisabled && (
            <span className="ml-auto inline-flex items-center gap-1 text-[10px] font-medium uppercase tracking-wide text-amber-600">
              <i className="fi fi-rr-lock text-[9px]" />
              Locked
            </span>
          )}
        </div>
      </button>

      <div className="relative px-4 py-5 sm:px-5 sm:py-6">
        {isDisabled && disabledMessage && (
          <div className="mb-4 flex items-start gap-3 rounded-xl border border-amber-100 bg-amber-50/80 px-4 py-3 text-sm text-amber-900">
            <i className="fi fi-rr-info relative top-0.5 text-amber-600" />
            <span>{disabledMessage}</span>
          </div>
        )}
        <div
          className={isDisabled ? "pointer-events-none opacity-45" : ""}
          {...contentProps}
        >
          {children}
        </div>
      </div>
    </section>
  );
};

export default SectionShell;
